import { PaginationBarColor } from "./types";

export const colorScheme: Record<
  PaginationBarColor,
  { indicatorClassName: string; bgClassName: string }
> = {
  [PaginationBarColor.Primary]: {
    indicatorClassName: "bg-primary",
    bgClassName: "bg-primary-light",
  },
};
